import { TextField, TextFieldProps } from '@mui/material';

const BaseInput = ({ ...props }: TextFieldProps) => {
  return <TextField fullWidth margin='dense' size='small' {...props} />;
};

export default BaseInput;
